import React, {Component} from 'react'
import { connect } from 'react-redux'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Table from 'react-bootstrap/Table'


import {SET_LOCATION} from './actions'


class LocationSelection extends Component {
	
	
	constructor(props) {
		super(props)
		this.state={positionedLocations:[], show:this.props.show, highlightedloc:undefined}
		this.SelectLocation = this.SelectLocation.bind(this)
	}
	componentDidMount() {
		const { childRef } = this.props;
		childRef(this);
	}
	componentWillUnmount() {
		const { childRef } = this.props;
		childRef(undefined);
	}
	
	render() {
		console.log("locations:"+JSON.stringify(this.state.positionedLocations))
		//console.log("state:"+JSON.stringify(this.state))
		return (
			
			<Modal show={this.state.selectLocation} onHide={()=>this.setState({selectLocation:false})} size="lg" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static">
						<Modal.Header closeButton>
						{ this.state.highlightedloc===undefined && <Modal.Title>Selecteer de locatie</Modal.Title>}
						</Modal.Header>
						<Modal.Body>
							<Table borderless size="sm" className="p-0 m-0">
								<tbody className="p-0 m-0">
								{
									this.state.positionedLocations.map( (locRow,r) => {
										return (
												<tr key={r} className="p-0 m-0" style={{height:'1em'}}>
													{
														locRow.map((loc,c)=> {
															if (loc.name===null ||loc.name===undefined || loc.name===" ") return <td key={c} className="p-0 m-0" style={{width:25}}/>
															return (<td key={c} className="m-0" style={{padding:'0.1875rem'}}>
																				<Button className="m-0" variant={this.state.highlightedloc===loc.name?"danger":"primary"} style={{width:'100%', padding:'0.1875rem', fontSize:'0.75rem'}} onClick={()=>{
																				if (this.state.highlightedloc!==undefined)
																					return
																				this.setState({selectLocation:false}); 
																				if (this.props.onLocationSelected)
																				{
																					this.props.onLocationSelected(loc.name)
																				}
																				else
																				{
																					this.props.setLocation(loc.name);
																				}	
																			}}>
																			{loc.name}
																		</Button>
																	</td>)
														})
													}
												</tr>
												)
									})
								}
								</tbody>
							</Table>
						</Modal.Body>
						
					</Modal>
			
	
		)
	}
	
	buildMap(){
		let locs=[]
		let minRow=1000
		let maxRow=-1000
		let minCol=1000
		let maxCol=-1000
		this.props.locations.forEach(loc => {
			
			if (loc.col==null || loc.row==null) return
			
			if (loc.col<minCol)
				minCol = loc.col
			if (loc.col>maxCol)
				maxCol = loc.col
			if (loc.row<minRow)
				minRow = loc.row
			if (loc.row>maxRow)
				maxRow = loc.row
		})
		for(var r = minRow; r<=maxRow ; r++)
		{
			let locCols=[]
			for(var c = minCol; c<=maxCol ; c++)
			{
				locCols.push({name:null})
			}
			locs.push(locCols)
		}
		this.props.locations.forEach(loc => {
			if (loc.col==null || loc.row==null) return
			
			locs[loc.row-minRow][loc.col-minCol]=loc
		})
		
		return locs
	}
	
	SelectLocation(){
		let locs = this.buildMap()
		//console.log("positionedLocations:"+JSON.stringify(locs))
		this.setState({selectLocation:true, positionedLocations:locs, highlightedloc:undefined})
	}
	
	ShowLocation(highlightedloc){
		let locs = this.buildMap()
		console.log("positionedLocations:"+JSON.stringify(locs))
		console.log("highlightedloc:"+JSON.stringify(highlightedloc))
		this.setState({selectLocation:true, positionedLocations:locs, highlightedloc})
	}
	
}
function mapDispatchToProps(dispatch) {
	return {
		setLocation: (location) => dispatch({type:SET_LOCATION, location})
	}
}

function mapStateToProps(state) {
	return {
		locations: state.app.locations
		}
}
  
export default connect(mapStateToProps, mapDispatchToProps)(LocationSelection);  





